export const ZOOM_IN = 'ZOOM_IN';
export const zoomIn = () => ({
    type: ZOOM_IN,
});

export const ZOOM_OUT = 'ZOOM_OUT';
export const zoomOut = () => ({
    type: ZOOM_OUT,
});

export const SET_ZOOM = 'SET_ZOOM';
export const setZoom = zoom => ({
    type: SET_ZOOM,
    zoom,
});

export const SET_CENTER = 'SET_CENTER';
export const setCenter = latLng => ({
    type: SET_CENTER,
    latLng,
});

export const TOGGLE_HEADQUARTERS = 'TOGGLE_HEADQUARTERS';
export const toggleHeadquarters = () => ({
    type: TOGGLE_HEADQUARTERS,
});
